export default [
  "AllBright Townhouse",
  "AllBright Accelerate",
  "AllBright Elevate",
  "Elevate to the Board",
  "AllBright Business",
] as const;
